import { isEmail } from './validator'

const EMAIL_FAKE = '@tc-email.fake'

export const normalizeFakeEmail = (email = '') =>
  isEmail(email) ? email : `${email}${EMAIL_FAKE}`

export const removeFakeEmail = (email = '') => email.replace(EMAIL_FAKE, '')

export default {
  normalizeFakeEmail,
  removeFakeEmail,
}
